import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as asset from '../asset'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: asset.RESOURCE.payload.dimension.partialId,
      partialId: asset.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Is this asset owned by the institution?',
    isOptional: true,
    name: 'Ownership',
    partialId: PartialId.Standard.create('ownership'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.assetOwnership.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
